import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { GripVertical } from 'lucide-react';

interface DraggableMetricProps {
  id: string;
  metric: {
    id: string;
    name: string;
    enabled: boolean;
  };
  onToggle: () => void;
  disabled: boolean;
}

export function DraggableMetric({ id, metric, onToggle, disabled }: DraggableMetricProps) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
    position: 'relative' as const,
    zIndex: isDragging ? 1 : 0,
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      className="flex items-center gap-3 p-2 bg-muted/30 rounded-lg group"
    >
      <div {...attributes} {...listeners} className="cursor-grab active:cursor-grabbing">
        <GripVertical className="w-4 h-4 text-muted-foreground" />
      </div>
      
      <span className="flex-1">{metric.name}</span>
      
      <button
        onClick={onToggle}
        disabled={disabled && !metric.enabled}
        className={`relative inline-flex h-5 w-9 items-center rounded-full transition-colors ${
          metric.enabled ? 'bg-primary' : 'bg-muted'
        } ${disabled && !metric.enabled ? 'cursor-not-allowed opacity-50' : ''}`}
      >
        <span
          className={`${
            metric.enabled ? 'translate-x-5' : 'translate-x-1'
          } inline-block h-3 w-3 transform rounded-full bg-white transition-transform`}
        />
      </button>
    </div>
  );
}